'use client'

import React from 'react'
import { CollectionArchive } from '@/ui/components/CollectionArchive'
import { BaseGatedArchiveClientProps } from '@/ui/blocks/shared/gatedArchiveTypes'
import { CardType } from '@/ui/components/Card/types'
import { mapProductsToCardProps } from '@/lib/mappers/productsMappers'

/**
 * Client component for CompatibleProductsArchive
 * Delegates all logic to CollectionArchive with gating support
 */
export const CompatibleProductsArchiveClient: React.FC<BaseGatedArchiveClientProps> = (props) => {
  const {
    archiveId,
    initialData,
    fetchCollectionDataAction,
    isGated,
    gateConfig,
    where,
    locale,
    limit,
    gridCols,
    emptyStateType,
    emptyStateButton,
    emptyStateHasButton,
  } = props

  return (
    <CollectionArchive
      archiveId={archiveId}
      initialData={initialData}
      fetchCollectionDataAction={fetchCollectionDataAction}
      collection="products"
      locale={locale}
      where={where}
      limit={limit}
      gridCols={gridCols}
      cardType={CardType.StandardFavorite}
      mapper={mapProductsToCardProps}
      loadMoreStrategy="pagination"
      isGated={isGated}
      gateConfig={gateConfig}
      emptyStateType={emptyStateType}
      emptyStateButton={emptyStateButton}
      emptyStateHasButton={emptyStateHasButton}
    />
  )
}
